export default `
  <div class="wb-doc-page">
  <div class="doc-main-title">一、積分收益</div>
  <div class="doc-text doc-pb28">用戶所獲得的積分，系統每天按用戶個人新增積分在社區所占比例，根據獎池方式派發現金獎勵。</div>
  <div class="doc-text doc-pb28">用戶當天發文及互動所獲得的積分統計為當天積分收益，系統按用戶當天新增積分在整個社區的貢獻比例，根據獎池方式派發相應比例現金獎勵。</div>
  <div class="doc-text doc-pb28">互動包括：閱讀、點贊/被點贊、評論/被評論、回復/被回復、分享/被分享。 （發文及分享一天最多計3篇為有效收益積分，評論、點贊不限）</div>
  <div class="doc-text doc-pb28">積分收益：派發為每天0點後，系統自動統計前一天社區新增積分總數據，並根據用戶個人當天新增積分貢獻比例派發現金獎勵至用戶收益帳號。</div>

  <div class="doc-main-title">二、收益提現</div>
  <div class="doc-text doc-pb28">用戶可在【我的-社區收益】查看獎勵並申請提現，收益帳號累積滿200港元以上可提現，提現只支持轉為人民幣提現，每週三統一進行提現審核，匯款週期一般為7個工作日內處理完成，節假日順延。</div>
  </div>
`
